
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Role Type', value: 'role_type', align: 'start' },
  { text: 'Role', value: 'role', align: 'start' },
  { text: 'Actions', value: 'action', width: '100'},
]);

export const editedItem = {
  role: '',
  description: '',
  roleType: '',
};

export const defaultItem = {
  role: '',
  description: '',
  roleType: ''
};

export const search = {
  role: '',
  description: '',
  role_type: '',
};

